export default __webpack_public_path__ + "static/media/study-about-2.1c1bcbcb.png";